{
  "i18n.app.optional": "(facoltativo)",

  "i18n.loadingSpinner.title": "Caricamento...",

  "i18n.salon.init.error": "Inizializzazione del salone non riuscita",
  "i18n.salon.notReady": "Questo salone non è ancora pronto.",

  "i18n.activity.price": "Prezzo",

  "i18n.booking.timezoneNotice": "Le fasce orarie sono nel fuso orario:",
  "i18n.booking.selectService": "Seleziona il servizio",
  "i18n.booking.selectDateTime": "Seleziona data/ora",
  "i18n.booking.guestDetails": "Dettagli ospite",
  "i18n.booking.reviewAndBook": "Rivedi e prenota",
  "i18n.booking.appointmentDetails": "Dettagli appuntamento",
  "i18n.booking.date": "Data",
  "i18n.booking.time": "Ora",
  "i18n.booking.reviewDescription": "La preghiamo di verificare la selezione e confermare la prenotazione.",
  "i18n.booking.bookAppointment": "Prenota appuntamento",
  "i18n.booking.confirmation": "Conferma",
  "i18n.booking.confirmationDescription": "La prenotazione è confermata. Riceverà un'email di conferma.",
  "i18n.booking.selectSlot": "Selezioni una fascia oraria per prenotare un appuntamento",
  "i18n.booking.noSlotsAvailable": "Nessun appuntamento disponibile",
  "i18n.booking.noServicesAvailable": "Nessun servizio disponibile",
  "i18n.booking.dateIsInPast": "La data è nel passato",
  "i18n.booking.tooFarInAdvance": "Questa data non è ancora disponibile per la prenotazione",
  "i18n.booking.email": "Email",
  "i18n.booking.emailPlaceholder": "la.tua.email@esempio.it",
  "i18n.booking.email.required": "L'email è obbligatoria",
  "i18n.booking.email.emailFormat": "Inserisca un indirizzo email valido",
  "i18n.booking.email.maxLength": "L'email può contenere al massimo 255 caratteri",
  "i18n.booking.name": "Nome",
  "i18n.booking.namePlaceholder": "Il suo nome",
  "i18n.booking.guestName.maxlength": "Il nome può contenere al massimo 100 caratteri",
  "i18n.booking.phone": "Telefono",
  "i18n.booking.phonePlaceholder": "Il suo numero di telefono",
  "i18n.booking.guestPhone.maxlength": "Il numero di telefono può contenere al massimo 50 caratteri",
  "i18n.booking.guestPhone.invalid": "Il numero di telefono può contenere solo cifre e i caratteri + - ( ) . / e spazi",
  "i18n.booking.comment": "Nota",
  "i18n.booking.commentPlaceholder": "Aggiunga richieste particolari o note...",
  "i18n.booking.comment.maxlength": "La nota può contenere al massimo 500 caratteri",
  "i18n.booking.appointmentWith": "Appuntamento con",
  "i18n.booking.updateBooking": "Aggiorna appuntamento",
  "i18n.booking.today": "Oggi",
  "i18n.booking.datePicker": "Selettore data",
  "i18n.booking.previousMonth": "Mese precedente",
  "i18n.booking.nextMonth": "Mese successivo",

  "i18n.bookingDetails.loadingSpinner.subTitle": "I suoi dati vengono caricati",
  "i18n.bookingDetails.title": "Dettagli prenotazione",
  "i18n.bookingDetails.bookingRef": "Riferimento prenotazione",
  "i18n.bookingDetails.guest": "Ospite",
  "i18n.bookingDetails.phone": "Telefono",
  "i18n.bookingDetails.email": "Email",
  "i18n.bookingDetails.service": "Servizio",
  "i18n.bookingDetails.date": "Data",
  "i18n.bookingDetails.time": "Ora",
  "i18n.bookingDetails.comment": "Note",

  "i18n.modalConfirmCancel.title": "Annullare la prenotazione",
  "i18n.modalConfirmCancel.subtitle": "Desidera davvero annullare questa prenotazione? Questa azione non può essere annullata.",
  "i18n.modalConfirmCancel.confirm": "Sì, annulla prenotazione",
  "i18n.modalConfirmCancel.cancel": "Mantieni prenotazione",

  "i18n.bookingNotFound.notFound.title": "Prenotazione non trovata",
  "i18n.bookingNotFound.notFound.subtitle": "Questa prenotazione non è stata trovata. Potrebbe essere già stata annullata oppure il link non è valido.",

  "i18n.cancelBooking.title": "Annullare la prenotazione",
  "i18n.cancelBooking.subtitle": "Desidera davvero annullare questa prenotazione?",
  "i18n.cancelBooking.doCancelBooking": "Annulla prenotazione",
  "i18n.cancelBooking.notCancellable.title": "Annullamento non più possibile",
  "i18n.cancelBooking.notCancellable.subtitle": "Il termine per annullare questa prenotazione è scaduto. Contatti direttamente il salone se ha bisogno di assistenza.",
  "i18n.cancelBooking.delete.error": "Non è stato possibile annullare la prenotazione. Riprovi.",
  "i18n.cancelBooking.delete.tooLate": "Questa prenotazione non può più essere annullata.",
  "i18n.cancelBooking.deleted.title": "Prenotazione annullata",
  "i18n.cancelBooking.deleted.subtitle": "La prenotazione è stata annullata con successo.",
  "i18n.cancelBooking.deleted.closePage": "Può ora chiudere questa pagina in sicurezza.",
  "i18n.booking.notEditable.title": "Prenotazione non più modificabile",
  "i18n.booking.notEditable.subtitle": "Il termine per modificare questa prenotazione è scaduto. Contatti direttamente il salone se desidera apportare modifiche.",
  "i18n.booking.save.conflict": "Questa fascia oraria non è più disponibile. Selezioni un altro appuntamento.",
  "i18n.booking.save.error": "Non è stato possibile salvare la prenotazione. Riprovi.",
  "i18n.booking.load.error": "Non è stato possibile caricare i dettagli della prenotazione. Verifichi il riferimento e riprovi.",

  "i18n.confirmBooking.title": "Prenotazione confermata!",
  "i18n.confirmBooking.subtitle": "Il suo appuntamento è stato prenotato con successo. Un'email di conferma è in arrivo.",
  "i18n.confirmBooking.addToCalendarIcs": "Aggiungi al calendario (.ics)",
  "i18n.confirmBooking.addToCalendarGoogle": "Calendario Android/Google",
  "i18n.addToCalendar.with": "Con",
  "i18n.addToCalendar.guest": "Ospite",
  "i18n.addToCalendar.phone": "Telefono",
  "i18n.confirmBooking.newBooking": "Prenota un altro appuntamento",
  "i18n.confirmBooking.closePage": "Può ora chiudere questa pagina in sicurezza. La sua prenotazione è stata salvata.",

  "i18n.footer.privacyPolicy": "Informativa sulla privacy",
  "i18n.footer.termsOfService": "Termini di servizio",

  "i18n.signUp.legal.1": "Accetto di rispettare ",
  "i18n.signUp.legal.2": " e ",
  "i18n.signUp.legal.3": "",

  "i18n.home.title": "Prenotazioni online SmallSalon",
  "i18n.home.badge": "Piattaforma di prenotazione online",
  "i18n.home.headline1": "Prenoti il suo prossimo",
  "i18n.home.headline2": "appuntamento in salone",
  "i18n.home.headline3": "in pochi secondi.",
  "i18n.home.subheadline": "SmallSalon la mette in contatto con saloni indipendenti e stilisti autonomi nella sua zona. Scopra i servizi, scelga l'appuntamento e confermi - senza telefonate.",
  "i18n.home.feature1": "Disponibilità in tempo reale - sempre aggiornata",
  "i18n.home.feature2": "Conferma immediata con promemoria via email",
  "i18n.home.feature3": "Ripianifichi o annulli in qualsiasi momento, senza stress",
  "i18n.home.cta.website": "Visita SmallSalon.io",
  "i18n.home.cta.register": "Crea un account",
  "i18n.home.solo.heading": "È un proprietario di salone individuale?",
  "i18n.home.solo.description": "Ottenga la sua pagina di prenotazione personale. Riceva prenotazioni online, invii promemoria automatici e mantenga il suo calendario pieno - tutto in un unico posto. Piattaforma di prenotazione leggera per lavoratori autonomi.",
  "i18n.home.solo.cta": "Inizia gratuitamente →",

  "i18n.privacyPolicy.backButton": "← Indietro",
  "i18n.privacyPolicy.title": "Informativa sulla privacy",
  "i18n.privacyPolicy.effectiveDate": "Data di entrata in vigore:",
  "i18n.privacyPolicy.effectiveDateValue": "1° giugno 2026",
  "i18n.privacyPolicy.intro": "La presente informativa sulla privacy spiega come Concrete Code GmbH tratta i dati personali in relazione all'applicazione di prenotazione SmallSalon rivolta ai clienti.",

  "i18n.privacyPolicy.s1.title": "1. Titolare del trattamento",
  "i18n.privacyPolicy.s1.address": "Concrete Code GmbH\nCH-8304 Wallisellen\nSvizzera",
  "i18n.privacyPolicy.s1.email": "E-mail: info@smallsalon.io",

  "i18n.privacyPolicy.s2.title": "2. Ambito di applicazione",
  "i18n.privacyPolicy.s2.p1": "La presente informativa si applica ai clienti che utilizzano l'applicazione di prenotazione SmallSalon per visualizzare le informazioni del salone, sfogliare i servizi e prenotare appuntamenti con proprietari di saloni indipendenti.",
  "i18n.privacyPolicy.s2.p2": "L'applicazione di prenotazione SmallSalon è destinata esclusivamente agli utenti di età pari o superiore a 18 anni.",

  "i18n.privacyPolicy.s3.title": "3. Legge applicabile",
  "i18n.privacyPolicy.s3.p1": "Trattiamo i dati personali in conformità con la legge svizzera sulla protezione dei dati e, ove applicabile, con il Regolamento generale sulla protezione dei dati (GDPR) dell'Unione europea.",

  "i18n.privacyPolicy.s4.title": "4. Ruolo di SmallSalon e dei proprietari di saloni",
  "i18n.privacyPolicy.s4.p1": "I proprietari di saloni che utilizzano SmallSalon operano come imprese indipendenti.",
  "i18n.privacyPolicy.s4.p2": "I proprietari di saloni sono gli unici responsabili per:",
  "i18n.privacyPolicy.s4.li1": "I propri servizi e la relativa qualità",
  "i18n.privacyPolicy.s4.li2": "Le informazioni sui prezzi",
  "i18n.privacyPolicy.s4.li3": "Gli orari e la disponibilità",
  "i18n.privacyPolicy.s4.li4": "Le politiche di prenotazione e cancellazione",
  "i18n.privacyPolicy.s4.li5": "Le proprie relazioni con i clienti",
  "i18n.privacyPolicy.s4.li6": "L'utilizzo e il trattamento dei dati dei clienti nell'ambito della propria attività",
  "i18n.privacyPolicy.s4.p3": "SmallSalon fornisce l'infrastruttura tecnica e la piattaforma per la prenotazione di appuntamenti e la comunicazione.",
  "i18n.privacyPolicy.s4.p4": "I proprietari di saloni agiscono come titolari indipendenti del trattamento dei dati dei clienti relativi alla propria attività e alle relazioni con i clienti.",
  "i18n.privacyPolicy.s4.p5": "I clienti potrebbero dover contattare direttamente il proprietario del salone riguardo a:",
  "i18n.privacyPolicy.s4.li7": "Problemi relativi agli appuntamenti",
  "i18n.privacyPolicy.s4.li8": "Controversie sui servizi",
  "i18n.privacyPolicy.s4.li9": "Correzioni di prenotazione",
  "i18n.privacyPolicy.s4.li10": "Richieste di cancellazione relative agli appuntamenti",

  "i18n.privacyPolicy.s5.title": "5. Dati personali raccolti",
  "i18n.privacyPolicy.s5.p1": "Durante una prenotazione, possono essere raccolti i seguenti dati personali:",
  "i18n.privacyPolicy.s5.li1": "Nome del cliente",
  "i18n.privacyPolicy.s5.li2": "Indirizzo e-mail",
  "i18n.privacyPolicy.s5.li3": "Commenti o note sulla prenotazione",
  "i18n.privacyPolicy.s5.li4": "Servizio o attività selezionati",
  "i18n.privacyPolicy.s5.li5": "Data e ora dell'appuntamento",
  "i18n.privacyPolicy.s5.p2": "I numeri di telefono non vengono raccolti tramite l'applicazione di prenotazione SmallSalon.",
  "i18n.privacyPolicy.s5.p3": "Gli indirizzi e-mail dei clienti sono necessari per inviare le comunicazioni relative alle prenotazioni.",
  "i18n.privacyPolicy.s5.p4": "I commenti di prenotazione sono limitati a un massimo di 250 caratteri.",

  "i18n.privacyPolicy.s6.title": "6. Dati tecnici e di sicurezza",
  "i18n.privacyPolicy.s6.p1": "Per finalità tecniche, operative e di sicurezza, possiamo trattare:",
  "i18n.privacyPolicy.s6.li1": "Indirizzi IP",
  "i18n.privacyPolicy.s6.li2": "Informazioni sul browser",
  "i18n.privacyPolicy.s6.li3": "Informazioni sul dispositivo",
  "i18n.privacyPolicy.s6.li4": "Informazioni relative alla sessione",
  "i18n.privacyPolicy.s6.li5": "Log di sicurezza e tecnici",
  "i18n.privacyPolicy.s6.p2": "I clienti non creano account e non vengono autenticati tramite l'applicazione di prenotazione.",

  "i18n.privacyPolicy.s7.title": "7. Comunicazioni sulle prenotazioni",
  "i18n.privacyPolicy.s7.p1": "SmallSalon può inviare automaticamente:",
  "i18n.privacyPolicy.s7.li1": "E-mail di conferma prenotazione",
  "i18n.privacyPolicy.s7.li2": "E-mail di promemoria appuntamento",
  "i18n.privacyPolicy.s7.li3": "Notifiche di cancellazione",
  "i18n.privacyPolicy.s7.li4": "Notifiche di riprogrammazione",
  "i18n.privacyPolicy.s7.p2": "Le e-mail vengono inviate tramite Amazon Web Services Simple Email Service (AWS SES).",
  "i18n.privacyPolicy.s7.p3": "La consegna di e-mail e notifiche non può essere garantita. Le e-mail potrebbero essere ritardate, bloccate, filtrate o classificate come spam da fornitori terzi.",

  "i18n.privacyPolicy.s8.title": "8. Politiche di cancellazione e riprogrammazione",
  "i18n.privacyPolicy.s8.p1": "Ogni proprietario di salone definisce autonomamente le proprie regole di cancellazione e modifica.",
  "i18n.privacyPolicy.s8.p2": "Possono essere applicati termini di modifica. Dopo la scadenza definita, le prenotazioni possono essere bloccate e non più modificabili tramite la piattaforma.",
  "i18n.privacyPolicy.s8.p3": "I proprietari di saloni possono modificare autonomamente le proprie regole di cancellazione e modifica.",

  "i18n.privacyPolicy.s9.title": "9. Pagamenti",
  "i18n.privacyPolicy.s9.p1": "SmallSalon non elabora i pagamenti dei clienti.",
  "i18n.privacyPolicy.s9.p2": "Nessuna informazione su carte di pagamento o bancarie viene raccolta dai clienti tramite l'applicazione di prenotazione SmallSalon.",
  "i18n.privacyPolicy.s9.p3": "I pagamenti per i servizi del salone sono gestiti direttamente tra il cliente e il proprietario del salone al di fuori della piattaforma.",

  "i18n.privacyPolicy.s10.title": "10. Hosting e infrastruttura",
  "i18n.privacyPolicy.s10.p1": "SmallSalon è ospitato su Amazon Web Services (AWS), principalmente nella regione eu-central-1.",
  "i18n.privacyPolicy.s10.p2": "La piattaforma utilizza i seguenti servizi AWS:",
  "i18n.privacyPolicy.s10.li1": "CloudFront",
  "i18n.privacyPolicy.s10.li2": "S3",
  "i18n.privacyPolicy.s10.li3": "Lambda",
  "i18n.privacyPolicy.s10.li4": "DynamoDB",
  "i18n.privacyPolicy.s10.li5": "Cognito",
  "i18n.privacyPolicy.s10.p3": "Backup, log tecnici e log di sicurezza possono essere trattati per finalità di manutenzione, diagnostica, sicurezza, prevenzione delle frodi e operative.",

  "i18n.privacyPolicy.s11.title": "11. Cookie",
  "i18n.privacyPolicy.s11.p1": "L'applicazione di prenotazione può utilizzare cookie necessari per:",
  "i18n.privacyPolicy.s11.li1": "Gestione delle sessioni",
  "i18n.privacyPolicy.s11.li2": "Preferenze linguistiche",
  "i18n.privacyPolicy.s11.li3": "Funzionalità del processo di prenotazione",
  "i18n.privacyPolicy.s11.p2": "L'applicazione di prenotazione SmallSalon non utilizza attualmente cookie analitici, tracker pubblicitari, pixel di marketing o tecnologie di tracciamento simili.",

  "i18n.privacyPolicy.s12.title": "12. Terze parti e condivisione dei dati",
  "i18n.privacyPolicy.s12.p1": "I dati personali possono essere trattati da fornitori terzi ove necessario per gestire la piattaforma.",
  "i18n.privacyPolicy.s12.p2": "Questi fornitori includono:",
  "i18n.privacyPolicy.s12.li1": "Amazon Web Services per hosting, archiviazione, infrastruttura e invio di e-mail",
  "i18n.privacyPolicy.s12.p3": "I dati di prenotazione vengono condivisi con il proprietario del salone interessato per la gestione degli appuntamenti.",
  "i18n.privacyPolicy.s12.p4": "Non vendiamo i dati personali dei clienti.",
  "i18n.privacyPolicy.s12.p5": "Il personale di supporto o amministrativo può accedere ai dati relativi alle prenotazioni ove necessario per supporto, manutenzione, risoluzione dei problemi, sicurezza, prevenzione delle frodi o conformità legale.",

  "i18n.privacyPolicy.s13.title": "13. Conservazione dei dati",
  "i18n.privacyPolicy.s13.p1": "I dati relativi alle prenotazioni possono essere conservati fino a un anno.",
  "i18n.privacyPolicy.s13.p2": "I proprietari di saloni possono eliminare autonomamente le prenotazioni e i dati dei clienti correlati.",
  "i18n.privacyPolicy.s13.p3": "Se un proprietario di salone elimina il proprio account, i dati di prenotazione associati possono essere eliminati anch'essi.",
  "i18n.privacyPolicy.s13.p4": "I backup e alcuni log di sicurezza o prevenzione delle frodi possono rimanere temporaneamente archiviati per ragioni tecniche, operative o legali.",

  "i18n.privacyPolicy.s14.title": "14. Sicurezza",
  "i18n.privacyPolicy.s14.p1": "Adottiamo misure tecniche e organizzative adeguate per contribuire alla protezione dei dati personali.",
  "i18n.privacyPolicy.s14.p2": "Queste misure possono includere:",
  "i18n.privacyPolicy.s14.li1": "Crittografia HTTPS e TLS",
  "i18n.privacyPolicy.s14.li2": "Infrastruttura crittografata",
  "i18n.privacyPolicy.s14.li3": "Controlli di accesso",
  "i18n.privacyPolicy.s14.li4": "Sistemi di monitoraggio",
  "i18n.privacyPolicy.s14.li5": "Registrazione della sicurezza",
  "i18n.privacyPolicy.s14.li6": "Backup",
  "i18n.privacyPolicy.s14.p3": "Tuttavia, nessun sistema può garantire la sicurezza assoluta.",

  "i18n.privacyPolicy.s15.title": "15. I suoi diritti",
  "i18n.privacyPolicy.s15.p1": "Ai sensi della legge applicabile, i clienti possono avere diritti tra cui:",
  "i18n.privacyPolicy.s15.li1": "Accesso ai dati personali",
  "i18n.privacyPolicy.s15.li2": "Rettifica dei dati inesatti",
  "i18n.privacyPolicy.s15.li3": "Cancellazione dei dati personali",
  "i18n.privacyPolicy.s15.li4": "Opposizione a determinate attività di trattamento",
  "i18n.privacyPolicy.s15.li5": "Revoca del consenso ove applicabile",
  "i18n.privacyPolicy.s15.p2": "Le richieste possono essere inviate a: info@smallsalon.io",
  "i18n.privacyPolicy.s15.p3": "SmallSalon può supportare tecnicamente i proprietari di saloni nelle richieste di privacy dei clienti ove appropriato.",

  "i18n.privacyPolicy.s16.title": "16. Trasferimenti internazionali di dati",
  "i18n.privacyPolicy.s16.p1": "Alcuni fornitori di servizi possono trattare dati al di fuori della Svizzera o dello Spazio economico europeo.",
  "i18n.privacyPolicy.s16.p2": "Ove richiesto, possono essere utilizzate garanzie giuridiche adeguate come clausole contrattuali standard o altri meccanismi di trasferimento riconosciuti.",

  "i18n.privacyPolicy.s17.title": "17. Aggiornamenti della presente informativa sulla privacy",
  "i18n.privacyPolicy.s17.p1": "Possiamo aggiornare la presente informativa sulla privacy di tanto in tanto.",
  "i18n.privacyPolicy.s17.p2": "Il continuo utilizzo dell'applicazione di prenotazione SmallSalon dopo l'entrata in vigore degli aggiornamenti costituisce accettazione dell'informativa sulla privacy aggiornata.",

  "i18n.privacyPolicy.s18.title": "18. Legge regolatrice",
  "i18n.privacyPolicy.s18.p1": "La presente informativa sulla privacy è disciplinata dalla legge svizzera.",

  "i18n.privacyPolicy.s19.title": "19. Contatto",
  "i18n.privacyPolicy.s19.p1": "Per domande o richieste relative alla privacy, si prega di contattare:",
  "i18n.privacyPolicy.s19.address": "Concrete Code GmbH\nCH-8304 Wallisellen\nSvizzera",
  "i18n.privacyPolicy.s19.email": "E-mail: info@smallsalon.io",

  "i18n.tos.backButton": "← Indietro",
  "i18n.tos.title": "Condizioni di prenotazione",
  "i18n.tos.effectiveDate": "Data di entrata in vigore:",
  "i18n.tos.effectiveDateValue": "1° giugno 2026",
  "i18n.tos.intro1": "Le presenti Condizioni di prenotazione («Condizioni») disciplinano l'utilizzo della piattaforma di prenotazione SmallSalon da parte dei clienti che prenotano appuntamenti con proprietari di saloni indipendenti.",
  "i18n.tos.intro2": "Effettuando una prenotazione tramite SmallSalon, l'utente accetta le presenti Condizioni.",

  "i18n.tos.s1.title": "1. Informazioni sull'operatore",
  "i18n.tos.s1.address": "Concrete Code GmbH\nCH-8304 Wallisellen\nSvizzera",
  "i18n.tos.s1.contact": "Contatto: info@smallsalon.io",

  "i18n.tos.s2.title": "2. Scopo della piattaforma",
  "i18n.tos.s2.p1": "SmallSalon consente ai clienti di prenotare appuntamenti con proprietari di saloni indipendenti.",
  "i18n.tos.s2.p2": "I clienti possono prenotare appuntamenti senza creare un account cliente.",
  "i18n.tos.s2.p3": "SmallSalon fornisce la piattaforma tecnica utilizzata per la prenotazione di appuntamenti e la comunicazione.",
  "i18n.tos.s2.p4": "SmallSalon non garantisce la disponibilità degli appuntamenti.",

  "i18n.tos.s3.title": "3. Rapporto tra clienti e proprietari di saloni",
  "i18n.tos.s3.p1": "L'accordo di prenotazione esiste esclusivamente tra il cliente e il proprietario del salone.",
  "i18n.tos.s3.p2": "SmallSalon e Concrete Code GmbH:",
  "i18n.tos.s3.p2list": "- non sono saloni\n- non impiegano proprietari di saloni\n- non supervisionano i proprietari di saloni\n- non sono responsabili dei servizi del salone",
  "i18n.tos.s3.p3": "I proprietari di saloni sono pienamente e unicamente responsabili per:",
  "i18n.tos.s3.p3list": "- descrizioni dei servizi\n- informazioni sui prezzi\n- orari e disponibilità\n- immagini e contenuti caricati\n- qualità dei servizi\n- esecuzione degli appuntamenti\n- cancellazioni e riprogrammazioni\n- standard igienici\n- conformità legale e normativa",
  "i18n.tos.s3.p4": "Concrete Code GmbH e SmallSalon non sono responsabili per informazioni inaccurate, fuorvianti, obsolete, incomplete o illegali caricate o fornite dai proprietari di saloni.",

  "i18n.tos.s4.title": "4. Pagamenti",
  "i18n.tos.s4.p1": "SmallSalon non elabora i pagamenti tra clienti e proprietari di saloni.",
  "i18n.tos.s4.p2": "I pagamenti per i servizi del salone sono gestiti direttamente tra il cliente e il proprietario del salone, tipicamente in loco presso il salone.",
  "i18n.tos.s4.p3": "Concrete Code GmbH e SmallSalon non sono responsabili per:",
  "i18n.tos.s4.p3list": "- controversie di pagamento\n- rimborsi\n- disaccordi sui prezzi\n- transazioni fallite o contestate tra clienti e saloni",

  "i18n.tos.s5.title": "5. Regole di prenotazione e politiche di cancellazione",
  "i18n.tos.s5.p1": "I proprietari di saloni possono cancellare o riprogrammare appuntamenti a propria discrezione.",
  "i18n.tos.s5.p2": "I clienti possono cancellare o modificare appuntamenti in conformità con la politica di cancellazione individuale del salone.",
  "i18n.tos.s5.p3": "Ogni salone definisce il proprio termine di modifica della prenotazione, che determina con quanto anticipo i clienti possono cancellare o modificare gli appuntamenti.",
  "i18n.tos.s5.p4": "I termini di modifica sono generalmente compresi tra 0 e 48 ore prima dell'orario previsto dell'appuntamento.",
  "i18n.tos.s5.p5": "Una volta superato il termine di modifica, le prenotazioni possono essere bloccate e non più modificabili tramite la piattaforma.",
  "i18n.tos.s5.p6": "I clienti sono responsabili di verificare la politica di cancellazione e modifica del salone scelto prima di effettuare una prenotazione.",
  "i18n.tos.s5.p7": "I proprietari di saloni possono aggiornare le proprie politiche di cancellazione in qualsiasi momento, con le modifiche applicabili alle future modifiche di prenotazione.",
  "i18n.tos.s5.p8": "Gli appuntamenti mancati e le assenze sono di esclusiva responsabilità del cliente e del proprietario del salone.",

  "i18n.tos.s6.title": "6. Responsabilità dei clienti",
  "i18n.tos.s6.p1": "I clienti si impegnano a fornire informazioni di prenotazione accurate e complete.",
  "i18n.tos.s6.p2": "Le prenotazioni fraudolente, abusive, fuorvianti, false o spam sono severamente vietate.",
  "i18n.tos.s6.p3": "I clienti sono responsabili di garantire che i propri dati di contatto siano corretti e raggiungibili.",
  "i18n.tos.s6.p4": "Concrete Code GmbH e SmallSalon si riservano il diritto di bloccare o limitare l'accesso agli utenti che abusano della piattaforma.",

  "i18n.tos.s7.title": "7. Notifiche e comunicazioni",
  "i18n.tos.s7.p1": "SmallSalon può inviare conferme di prenotazione, promemoria, avvisi di cancellazione e altre comunicazioni operative relative agli appuntamenti.",
  "i18n.tos.s7.p2": "Concrete Code GmbH e SmallSalon non sono responsabili per notifiche non riuscite, ritardate, filtrate, bloccate o non consegnate, incluse le e-mail classificate come spam o altrimenti non ricevute.",

  "i18n.tos.s8.title": "8. Disponibilità della piattaforma",
  "i18n.tos.s8.p1": "SmallSalon è fornito «così com'è» e «secondo disponibilità».",
  "i18n.tos.s8.p2": "Concrete Code GmbH non garantisce la disponibilità ininterrotta della piattaforma.",
  "i18n.tos.s8.p3": "La piattaforma può occasionalmente diventare non disponibile a causa di manutenzione, aggiornamenti, problemi tecnici o fattori esterni.",
  "i18n.tos.s8.p4": "Concrete Code GmbH si riserva il diritto di modificare, sospendere o interrompere funzionalità o parti della piattaforma in qualsiasi momento.",

  "i18n.tos.s9.title": "9. Privacy e dati dei clienti",
  "i18n.tos.s9.p1": "I dati dei clienti relativi alle prenotazioni vengono condivisi con il proprietario del salone per la gestione degli appuntamenti.",
  "i18n.tos.s9.p2": "Dopo la prenotazione, i proprietari di saloni possono trattare autonomamente i dati dei clienti in base alle proprie pratiche sulla privacy e agli obblighi legali.",
  "i18n.tos.s9.p3": "I proprietari di saloni sono separatamente responsabili della conformità alle leggi applicabili in materia di privacy e protezione dei dati.",
  "i18n.tos.s9.p4": "L'utilizzo della piattaforma è disciplinato anche dall'Informativa sulla privacy.",

  "i18n.tos.s10.title": "10. Proprietà intellettuale",
  "i18n.tos.s10.p1": "La piattaforma SmallSalon, il software, il marchio, il design e la relativa proprietà intellettuale sono di proprietà di Concrete Code GmbH.",
  "i18n.tos.s10.p2": "I clienti non possono:",
  "i18n.tos.s10.p2list": "- copiare o riprodurre la piattaforma\n- effettuare ingegneria inversa sulla piattaforma\n- abusare o utilizzare impropriamente la piattaforma\n- tentare accessi non autorizzati a sistemi o dati",

  "i18n.tos.s11.title": "11. Esclusione di responsabilità",
  "i18n.tos.s11.p1": "Nella misura massima consentita dalla legge, Concrete Code GmbH e SmallSalon non sono responsabili per:",
  "i18n.tos.s11.p1list": "- servizi del salone o qualità dei servizi\n- lesioni o reazioni allergiche\n- insoddisfazione per i servizi del salone\n- appuntamenti mancati\n- prezzi inaccurati\n- descrizioni dei servizi inaccurate\n- controversie con i clienti\n- beni persi o danneggiati\n- interruzioni dell'attività\n- decisioni o azioni dei proprietari di saloni",
  "i18n.tos.s11.p2": "L'utilizzo della piattaforma è a proprio rischio.",

  "i18n.tos.s12.title": "12. Forza maggiore",
  "i18n.tos.s12.p1": "Concrete Code GmbH non sarà responsabile per ritardi, interruzioni o guasti causati da circostanze al di fuori del ragionevole controllo, inclusi, a titolo esemplificativo, catastrofi naturali, interruzioni di Internet, attacchi informatici, interruzioni di corrente, azioni governative, guerre, controversie lavorative o guasti di fornitori di servizi terzi.",

  "i18n.tos.s13.title": "13. Saloni indipendenti",
  "i18n.tos.s13.p1": "Tutti i saloni che utilizzano SmallSalon operano come imprese indipendenti.",
  "i18n.tos.s13.p2": "I singoli saloni possono avere le proprie politiche, regole di cancellazione, strutture tariffarie e procedure operative.",
  "i18n.tos.s13.p3": "I clienti dovrebbero esaminare attentamente le informazioni specifiche del salone prima di effettuare una prenotazione.",

  "i18n.tos.s14.title": "14. Modifiche alle presenti Condizioni",
  "i18n.tos.s14.p1": "Concrete Code GmbH può aggiornare o modificare queste Condizioni di tanto in tanto.",
  "i18n.tos.s14.p2": "Il continuo utilizzo della piattaforma dopo l'entrata in vigore delle Condizioni aggiornate costituisce accettazione delle Condizioni riviste.",

  "i18n.tos.s15.title": "15. Salvaguardia",
  "i18n.tos.s15.p1": "Se una disposizione delle presenti Condizioni viene ritenuta non valida o inapplicabile, le disposizioni rimanenti rimarranno pienamente valide e applicabili.",

  "i18n.tos.s16.title": "16. Legge regolatrice",
  "i18n.tos.s16.p1": "Le presenti Condizioni sono disciplinate dalle leggi della Svizzera.",
  "i18n.tos.s16.p2": "Qualsiasi controversia derivante dall'uso di SmallSalon sarà soggetta alla giurisdizione dei tribunali competenti della Svizzera.",

  "i18n.tos.s17.title": "17. Contatto",
  "i18n.tos.s17.p1": "Per domande legali, relative alla privacy o alla piattaforma, è possibile contattare:",
  "i18n.tos.s17.contact": "Concrete Code GmbH\ninfo@smallsalon.io"
}
